import { render, staticRenderFns } from "./orderThirdParticulars.vue?vue&type=template&id=7b066c1e&scoped=true&"
import script from "./orderThirdParticulars.vue?vue&type=script&lang=js&"
export * from "./orderThirdParticulars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b066c1e",
  null
  
)

export default component.exports